const AE_DETAILS_SECTION_KEY = 'project'
const MODULE_NAME = 'fulcrum/container/Project/ProjectExecutionSection'

const HEALTH_COLORS = {
  red: '#ff2a00',
  yellow: '#ffd800',
  green: '#82c908'
}

const FETCH_AE_DETAILS = MODULE_NAME + '/FETCH_AE_DETAILS'
const FETCH_AE_DETAILS_START = MODULE_NAME + '/FETCH_AE_DETAILS_START'
const FETCH_AE_DETAILS_SUCCESS = MODULE_NAME + '/FETCH_AE_DETAILS_SUCCESS'
const FETCH_AE_DETAILS_ERROR = MODULE_NAME + '/FETCH_AE_DETAILS_ERROR'

const FETCH_AE_DETAILS_SELECTION = MODULE_NAME + '/FETCH_AE_DETAILS_SELECTION'
const FETCH_AE_DETAILS_SELECTION_START = MODULE_NAME + '/FETCH_AE_DETAILS_SELECTION_START'
const FETCH_AE_DETAILS_SELECTION_SUCCESS = MODULE_NAME + '/FETCH_AE_DETAILS_SELECTION_SUCCESS'
const FETCH_AE_DETAILS_SELECTION_ERROR = MODULE_NAME + '/FETCH_AE_DETAILS_SELECTION_ERROR'

const POST_AE_DETAILS = MODULE_NAME + '/POST_AE_DETAILS'
const POST_AE_DETAILS_START = MODULE_NAME + '/POST_AE_DETAILS_START'
const POST_AE_DETAILS_SUCCESS = MODULE_NAME + '/POST_AE_DETAILS_SUCCESS'
const POST_AE_DETAILS_ERROR = MODULE_NAME + '/POST_AE_DETAILS_ERROR'

const UPDATE_AE_DETAILS_CHANGE = MODULE_NAME + '/UPDATE_AE_DETAILS_CHANGE'
const RESET_AE_DETAILS_CHANGE = MODULE_NAME + '/RESET_AE_DETAILS_CHANGE'

const UPDATE_AE_RESOURCE_LEVEL_ID = MODULE_NAME + '/UPDATE_AE_RESOURCE_LEVEL_ID'
const UPDATE_PROJECT_HEALTH_ID = MODULE_NAME + '/UPDATE_PROJECT_HEALTH_ID'
const UPDATE_AE_NOTES = MODULE_NAME + '/UPDATE_AE_NOTES'
const UPDATE_PROJECT_WAIVER = MODULE_NAME + '/UPDATE_PROJECT_WAIVER'

export {
  AE_DETAILS_SECTION_KEY,
  MODULE_NAME,
  HEALTH_COLORS,
  FETCH_AE_DETAILS,
  FETCH_AE_DETAILS_START,
  FETCH_AE_DETAILS_SUCCESS,
  FETCH_AE_DETAILS_ERROR,
  FETCH_AE_DETAILS_SELECTION,
  FETCH_AE_DETAILS_SELECTION_START,
  FETCH_AE_DETAILS_SELECTION_SUCCESS,
  FETCH_AE_DETAILS_SELECTION_ERROR,
  POST_AE_DETAILS,
  POST_AE_DETAILS_START,
  POST_AE_DETAILS_SUCCESS,
  POST_AE_DETAILS_ERROR,
  UPDATE_AE_DETAILS_CHANGE,
  RESET_AE_DETAILS_CHANGE,
  UPDATE_AE_RESOURCE_LEVEL_ID,
  UPDATE_PROJECT_HEALTH_ID,
  UPDATE_AE_NOTES,
  UPDATE_PROJECT_WAIVER
}

